import { createFileRoute } from "@tanstack/react-router";

import { searchSchema } from "./-schema";

export const Route = createFileRoute(
  "/_staff/equipment/_layout/settings/equipment-items/",
)({
  validateSearch: searchSchema,
});
